import { Controller } from '@hotwired/stimulus'
import Papa from 'papaparse'

// Local file upload controller using FileReader
// https://developer.mozilla.org/en-US/docs/Web/API/FileReader
export default class extends Controller {
    static targets = ['input']
    static values = {
        eventId: String,
    }

    upload() {
        const file = this.inputTarget.files[0] // Get the file
        if (!file) return

        const reader = new FileReader()
        reader.onload = (e) => {
            const content = e.target.result // File content
            const csv = Papa.parse(content) // Parse CSV
            // NOTE: we only return first column as both use cases expect lists
            const rows = csv.data?.map((row) => (row.length ? row[0] : '')) || []
            this.broadcastEvent(rows)
        }
        reader.readAsText(file)
    }

    // To hook into this use:
    //   document.addEventListener('file-uploaded-for-${this.eventIdValue}', (e.detail))
    broadcastEvent(files) {
        const uploadEvent = new CustomEvent('file-uploaded', {
            detail: files,
        })
        document.dispatchEvent(uploadEvent)
    }
}
